import React, { useState } from 'react';
import { Form, SonForm, StatusMessages, useForm } from '../../../../_lib/Form2';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { Icons } from '../../../atoms/SVG';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Button } from '../../Btn/Button';
import { ButtonIcon } from '../../Btn/Button/ButtonIcon';
import { BtnModifier } from '../../Btn';
import { useRefreshView } from '../../../../_lib/ViewFetcher';
import Event from '../../../../lib/EventEmitter';

type RequestManagementType = {
  approveForm: SonForm<any>;
  rejectForm: SonForm<any>;
};

/**
 * Renders the Buttons to accept or reject Member Requests
 */
export function RequestManagement({ approveForm, rejectForm }: RequestManagementType) {
  const { t } = useSonTranslation('MemberRow');
  const { delayedRefreshView } = useRefreshView();
  const [messageSuccess, setMessageSuccess] = useState(t('status.approveRequest.success'));
  const [messageFail, setMessageFail] = useState(t('status.approveRequest.fail'));

  const { formProps, fetchState } = useForm({ form: {
    method: 'POST',
    params: [],
    url: '',
  }, onError: (reason: any) => {
    if (reason?.request.responseURL.includes('RejectRequest')) {
      setMessageFail(t('status.rejectRequest.fail'));
    }
  }, onSuccess: (response) => {
    Event.emit('refetch-data', 'RequestManagement');

    if (response?.request.responseURL.includes('RejectRequest')) {
      setMessageSuccess(t('status.rejectRequest.success'));
    }
    delayedRefreshView();
  } });

  return (
    <Form
      {...formProps}
      modifier="no-padding"
    >
      <div className="accept-decline-form">
        <Heading hierarchy={3} className="accept-decline-form__headline">
          {t('actions.acceptRequest.headline')}
        </Heading>
        <div className="accept-decline-form__buttons">
          <Button
            type="submit"
            formAction={approveForm.url}
            modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
          >
            <ButtonIcon text={t('actions.acceptRequest.approve')} svgSpriteId={Icons.ACCEPT_CHECK} />
          </Button>
          <Button
            type="submit"
            formAction={rejectForm.url}
            modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_NO]}
          >
            <ButtonIcon text={t('actions.acceptRequest.reject')} svgSpriteId={Icons.DECLINE_CROSS} />
          </Button>
        </div>
      </div>
      <StatusMessages
        messageSuccess={messageSuccess}
        messageSending={t('status.sending')}
        messageFail={messageFail}
        fetchState={fetchState}
      />
    </Form>
  );
}
